import { observer } from "mobx-react";
import moment from "moment";
import * as React from "react";

import DetailsPageFields, {
  FieldType as DetailsField,
} from "@client/components/modules/DetailsPage/Fields";
import countries from "@server/CountriesList";
import { Licence } from "@typings/Licence";
import { Partner } from "@typings/Partner";
import { Tag } from "@typings/Tag";
import TagGroup from "@client/components/ui/TagGroup";

type Props = {
  partner: Partner | null;
  tags: Tag[];
  licences: Licence[];
};
@observer
class DetailsFields extends React.Component<Props> {
  render() {
    const { partner } = this.props;
    const countryItem: { name: string; code: string } | undefined =
      countries.find(c => (partner ? c.code === partner.country : null));
    let country: string | null = null;
    if (!countryItem) {
      country = partner?.country || null;
    } else {
      country = countryItem.name;
    }

    const fields: DetailsField[] = [
      {
        label: "Name",
        value: partner?.name,
      },
      {
        label: "ID",
        value: partner?.id,
      },
      {
        label: "Description",
        value: partner?.description,
      },
      {
        label: "Created At",
        value: moment(partner?.created_at).format("DD MMM YYYY HH:mm"),
      },
      {
        label: "PoC Per Customer",
        value: partner?.poc_licences,
      },
      {
        label: "Trials Per Customer",
        value: partner?.trial_licences,
      },
      {
        label: "License Manager",
        value: partner?.created_by,
      },
      {
        label: "Country",
        value: country,
      },
      {
        label: "Contact Name",
        value: partner?.contact,
      },
      {
        label: "Contact Email",
        value: partner?.email,
      },
      {
        label: "Licences Tags",
        value: (
          <TagGroup licences={this.props.licences} tags={this.props.tags} />
        ),
        useFullWidth: true,
      },
    ];

    return <DetailsPageFields fields={fields} />;
  }
}

export default DetailsFields;
